import launch from '../../config/launchArguments/launchArguments';
import { FC } from 'react';
import { useManageToken } from '../../hooks/authentification/useManageToken';
import { useOnMount } from '../../hooks/useOnMount';

export const TokenInjector: FC = () => {
  // when the app is under test we can inject an auth token via launch args
  // must be used within apollo context
  const manageToken = useManageToken();
  useOnMount(() => {
    const testToken = launch.getTestToken();
    if (testToken) {
      manageToken(testToken);
    }
  });
  return null;
};
